import type { definitions } from '@luxuryescapes/contract-trip'
import type { Moment } from 'moment'

import type { GetFlightScheduleResponse } from './types'
import { baseUri, getOptions } from '../utils'

import request from 'api/requestUtils'
import { ISO_DATE_FORMAT } from 'constants/dateFormats'

interface GetFlightScheduleArgs {
  flightCode: string
  departureDate: Moment
}

export async function getFlightSchedule(
  { flightCode, departureDate }: GetFlightScheduleArgs,
  accessToken?: string,
): Promise<Array<definitions['flightSchedule']>> {
  const carrierCode = flightCode.slice(0, 2)
  const flightNumber = flightCode.slice(2)

  return request
    .get<GetFlightScheduleResponse>(
      `${baseUri}/misc/flight-schedule?carrier=${carrierCode.toUpperCase()}&flightNumber=${flightNumber}&departureDate=${departureDate?.format(
        ISO_DATE_FORMAT,
      )}`,
      getOptions(accessToken),
    )
    .then((response) => response.result)
}
